import React, { useEffect, useState } from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import { Provider, useDispatch, useSelector } from 'react-redux';
import store from './redux/store';
import { GoogleOAuthProvider } from '@react-oauth/google';
import { checkLogin } from './redux/slices/authSlice';
import LottiePlayer from './Components/LottiePlayer';
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { HelmetProvider } from 'react-helmet-async';

const Root = () => {
  const dispatch = useDispatch();
  const { loading } = useSelector((state) => state.auth);
  const [isAuthChecked, setIsAuthChecked] = useState(false);

  useEffect(() => {
    dispatch(checkLogin()).then(() => {
      // console.log('checkLogin resolved, auth state:', store.getState().auth);
      setIsAuthChecked(true);
    });
  }, [dispatch]);

  if (loading || !isAuthChecked) {
    return (
      <div className="flex items-center justify-center min-h-screen">
        <LottiePlayer
          src="https://lottie.host/b2b25f7e-1811-405a-9986-2d09791950ef/8cJ75x5MYO.lottie"
          width={300}
          height={300}
        />
      </div>
    );
  }


  return (
    <>
      <App />
      <ToastContainer position="top-right" autoClose={3000} />
    </>
  );
};

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <Provider store={store}>
      <GoogleOAuthProvider clientId="186680882935-204johtq8shs41m1qpeupqeldilfg63t.apps.googleusercontent.com">
        <HelmetProvider>    {/* ✅ wrap here */}
          <Root />
        </HelmetProvider>
      </GoogleOAuthProvider>
    </Provider>
  </React.StrictMode>
);